module.exports = __webpack_public_path__ + "img/background-mobile-default.8e93a548.png";